<script setup>
import {
	EmptyPage,
	PageHeading,
	Input,
	Icon,
	Dropdown,
	Button,
	Checkbox,
	Select,
	Pagination,
	ProfilePicture,
} from "@components";
import { ref, reactive, onMounted, computed, watch } from "vue";

// router
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

// Appointment.
import { useAppointment } from "@store/appointment";
const $appointment = useAppointment();

// Service.
import { useService } from "@store/service";
const $service = useService();

// Staff.
import { useStaff } from "@store/staff";
const $staff = useStaff();

// Customer
import { useCustomer } from "@store/customer";
const $customer = useCustomer();

import { useSettings } from "@store/settings";
const $settings = useSettings();

import { useTransaction } from "@store/transaction";
const $transaction = useTransaction();

// Appointment status.
const $options = prebook_admin.options;

const bookingDatesOptions = ref([
	{ label: "Date: All", value: "all" },
	{ label: "Today", value: "today" },
	{ label: "Tomorrow", value: "tomorrow" },
	{ label: "Last 7 Days", value: "last7Days" },
	{ label: "Last 15 Days", value: "last15Days" },
	{ label: "This Month", value: "thisMonth" },
	{ label: "Last Month", value: "lastMonth" },
]);
const statusOptions = ref([]);
const showFilterDateText = computed(() => {
	let date = bookingDatesOptions.value.find(
		(item) => item.value == filter.value.date
	);

	if (filter.value.date == "all") {
		return "All";
	} else {
		return date.label;
	}
});

onMounted(async () => {
	await $transaction.fetchTransactions();
	// statusOptions.value= $options.appointment_statuses
	statusOptions.value = [
		{
			label: "Status: All",
			value: "all",
		},
		{
			label: "Approved",
			value: "approved",
		},
		{
			label: "Pending",
			value: "pending",
		},
		{
			label: "Canceled",
			value: "canceled",
		},
		{
			label: "Rejected",
			value: "rejected",
		},
	];

	// Object.entries($options.appointment_statuses).map(([key, value]) => {
	//     statusOptions.value.push({
	//         label: value,
	//         value: key
	//     })
	// })

	// bookingDatesOptions.value.push({
	//     label: 'All',
	//     value: 'All'
	// })

	await $appointment.fetchData();
	$service.fetchData();
	$staff.fetchData();
	$customer.fetchCustomers();
});

// Utils.
import { getPrice, toRGB } from "@utils";
import moment from "moment";

const activeAppointment = ref("");

/**
 * Toggles the active appointment based on its ID.
 *
 * @param {string} id - The ID of the appointment to toggle.
 * @return {string} The new value of the active appointment.
 */
const toggleAppointment = (id) => {
	activeAppointment.value = activeAppointment.value === id ? "" : id;
};

const toggleAppointmentItem = (event, id) => {
	if (event.target.classList.contains("appointment-item")) {
		toggleAppointment(id);
	}
};

// On change status.
const changeStatus = async (appointmentId) => {
	const appointment = $appointment.getById(appointmentId);
	appointment.disabled = true;
	const response = await $appointment.model(appointmentId).update(
		{
			meta: {
				status: appointment.meta.status,
			},
		},
		appointmentId
	);
	Log(response, appointment);
	appointment.disabled = false;
};

// Appointment date.
const getBookingTime = (ap) => {
	if (!ap.booking_time_start) {
		return "Unassigned";
	}

	return moment(ap.booking_time_start, "HH:mm").format("hh:mm A");
};

const filter = ref({
	search: "",
	date: "all",
	status: "all",
});

const filteredAppointments = computed(() => {
	let filteredArray = $appointment.getAppointments;
	if (!filteredArray || !filteredArray.length) return [];

	// Filter by status
	if (filter.value.status && filter.value.status !== "all") {
		filteredArray = filteredArray.filter(
			(ap) => ap.meta?.status == filter.value.status
		);
	}

	// Filter by date
	let today = moment().startOf("day");
	let tomorrow = moment().add(1, "days").startOf("day");
	let last7Days = moment().subtract(7, "days").startOf("day");
	let last15Days = moment().subtract(15, "days").startOf("day");
	let thisMonth = moment().startOf("month");
	let lastMonth = moment().subtract(1, "month").startOf("month");

	if (filter.value.date && filter.value.date !== "all") {
		filteredArray = filteredArray.filter((ap) => {
			if (!ap.booking_date) return;
			let appointmentDate = moment(ap.booking_date, "YYYY-MM-DD");

			if (filter.value.date == "today" && appointmentDate.isSame(today, "day"))
				return ap;
			if (
				filter.value.date == "tomorrow" &&
				appointmentDate.isSame(tomorrow, "day")
			)
				return ap;
			if (filter.value.date == "last7Days" && appointmentDate.isSame(last7Days))
				return ap;
			if (
				filter.value.date == "last15Days" &&
				appointmentDate.isSame(last15Days)
			)
				return ap;
			if (
				filter.value.date == "thisMonth" &&
				appointmentDate.format("MM") == thisMonth.format("MM")
			)
				return ap;
			if (
				filter.value.date == "lastMonth" &&
				appointmentDate.format("MM") == lastMonth.format("MM")
			)
				return ap;
		});
	}

	// Filter by search
	if (filter.value.search) {
		filteredArray = filteredArray.filter(
			(ap) =>
				String(ap.meta?.customer_name)
					.toLowerCase()
					.includes(filter.value.search.toLowerCase()) ||
				String(ap.meta?.service_name)
					.toLowerCase()
					.includes(filter.value.search.toLowerCase()) ||
				String(ap.meta?.staff_name)
					.toLowerCase()
					.includes(filter.value.search.toLowerCase())
		);
	}

	return filteredArray;
});

const time = ref(null);
const service = ref(null);
const customer = ref(null);
const staff = ref(null);

const getWidth = (totalPaginateAppointment) => {
	let maxWidth = { time: 0, service: 0, customer: 0, staff: 0 };

	if (totalPaginateAppointment == 0)
		return { time: 90, service: 197, customer: 180, staff: 120 };

	if (time.value) {
		Object.values(time.value).forEach((item) => {
			if (item.clientWidth > maxWidth.time) maxWidth.time = item.clientWidth;
		});
	}

	if (service.value) {
		Object.values(service.value).forEach((item) => {
			if (item.clientWidth > maxWidth.service)
				maxWidth.service = item.clientWidth;
		});
	}

	if (customer.value) {
		Object.values(customer.value).forEach((item) => {
			if (item.clientWidth > maxWidth.customer)
				maxWidth.customer = item.clientWidth;
		});
	}

	if (staff.value) {
		Object.values(staff.value).forEach((item) => {
			if (item.clientWidth > maxWidth.staff) maxWidth.staff = item.clientWidth;
		});
	}

	return maxWidth;
};

window.addEventListener("resize", () => {
	getWidth();
});

// Get paginated appointments.
const currentPage = ref(1);
const perPage = ref(10);
const sortBy = ref("appointment_id");
const sortDirection = ref("DESC");

const getPaginatedAppointments = computed(() => {
	let _appointments = filteredAppointments.value;

	// Sort.
	_appointments = _appointments.sort((a, b) => {
		if (Number(a[sortBy.value]) < Number(b[sortBy.value])) {
			return sortDirection.value == "ASC" ? -1 : 1;
		} else if (Number(a[sortBy.value]) > Number(b[sortBy.value])) {
			return sortDirection.value == "ASC" ? 1 : -1;
		}

		return 0;
	});

	getWidth(_appointments.length);

	return {
		total: _appointments.length,
		data: _appointments.slice(
			(currentPage.value - 1) * perPage.value,
			currentPage.value * perPage.value
		),
	};
});

const subtitle = computed(() => {
	let total = filteredAppointments.value.length;
	let pending = filteredAppointments.value.filter(
		(appointment) => appointment.meta?.status === "pending"
	).length;
	let approved = filteredAppointments.value.filter(
		(appointment) => appointment.meta?.status === "approved"
	).length;
	return `Total: ${total} | Pending: ${pending} | Approved: ${approved}`;
});

// Empty page.
const emptyPageContent = {
	heading: {
		title: `You haven’t any ${String(
			$settings.labels.appointment?.singular
		).toLowerCase()}`,
		subtitle: `To create a new ${String(
			$settings.labels.appointment?.singular
		).toLowerCase()}, simply click on the 'Add New' button. Alternatively, you can create a new ${String(
			$settings.labels.appointment?.singular
		).toLowerCase()} by clicking on '${String(
			$settings.labels.appointment?.singular
		).toLowerCase()}'.`,
	},
	buttonCta: [
		{
			title: `${$settings.labels.appointment?.singular}`,
			subtitle: `${
				$settings.labels.appointment?.plural
			} which can be created against ${String(
				$settings.labels.customer?.singular
			).toLowerCase()}.`,
			icon: "star04",
			link: { name: "appointment.add", query: { tab: "details" } },
		},
	],
};

const state = ref({
	allCheckbox: false,
});

const toggleAll = () => {
	state.value.allCheckbox == !state.value.allCheckbox;

	getPaginatedAppointments.value.data.forEach((appointment) => {
		appointment.meta.checkbox = state.value.allCheckbox;
	});
};

watch(filter.value, (newValue, oldValue) => {
	if ((newValue.date = oldValue.date)) {
		getPaginatedAppointments.value.data.forEach((appointment) => {
			state.value.allCheckbox = false;
			appointment.meta.checkbox = state.value.allCheckbox;
		});
	}
});

const getSelectedAppointments = computed(() => {
	return getPaginatedAppointments.value.data.filter(
		(ap) => ap.meta?.checkbox == true
	);
});

const deleteSelected = async () => {
	let ids = getSelectedAppointments.value.map((ap) => ap.appointment_id);

	// Confirm
	const confirm = await Prompt.fire({
		title: `Delete ${String(
			$settings.labels.appointment?.singular
		).toLowerCase()}`,
		message: `Are you sure you want to delete selected ${
			ids.length > 1 ? ids.length : ""
		} ${String($settings.labels.appointment?.singular).toLowerCase()}${
			ids.length > 1 ? "s" : ""
		}?`,
		ok: "Delete",
	});

	if (!confirm.ok) return;

	await $appointment.bulkDelete(ids);
	$appointment.fetchData();
};

watch(getSelectedAppointments, (newValue) => {
	if (newValue.length == 0) {
		state.value.allCheckbox = false;
	}
});

const deleteAppointment = async (appointment) => {
	if (!appointment.appointment_id)
		return Toast.error(
			`No ${String(
				$settings.labels.appointment?.singular
			).toLowerCase()} id found`
		);

	const response = await appointment.delete(appointment.appointment_id);

	if (response.success) {
		Toast.success(
			`${String(
				$settings.labels.appointment?.singular
			).toLowerCase()} deleted successfully`
		);
		await $appointment.fetchData();
	} else {
		// Toast.error(response.message)
	}
};

// const generateRandomText = (length) => {
//     let result = ''
//     let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
//     let charactersLength = characters.length

//     for (let i = 0; i < length; i++) {
//         result += characters.charAt(Math.floor(Math.random() * charactersLength))
//     }

//     return result
// }

// onMounted(() => {
//     for (let i = 0; i < 20; i++) {
//         $appointment.model().create({
//             "status": "publish",
//             "meta": {
//                 "price": 10,
//                 "deposit_amount": 0,
//                 "payment_method": "cash",
//                 "payment_status": "paid",
//                 "appointment_type": "Onsite",
//                 "status": "pending",
//                 "address": "",
//                 "service_name": "New",
//                 "service_duration": 1,
//                 "service_duration_unit": "minutes",
//                 "staff_email": "e3adc32d@blank-wp.local",
//                 "staff_phone": "885066158",
//                 "customer_id": "106",
//                 "customer_name": "MR22Fco0rR 8RtSJQUwpI",
//                 "customer_email": "zaoF9.customer@prebook.com",
//                 "customer_phone": "275553084",
//                 "staff_name": "yclQsr3n7QBqOi1"
//             },
//             "customer_id": "106",
//             "service_id": 8,
//             "staff_id": 54,
//             "booking_date": "2024-03-27",
//             "booking_time_start": "09:01",
//             "booking_time_end": "09:02",
//             "paid_amount": 10,
//             "payment_method": "cash",
//             "payment_status": "paid"
//         })
//     }
// })

const generateCustomerName = (first_name = null, last_name = null) => {
	if (first_name && last_name) {
		return `${first_name} ${last_name}`;
	} else if (first_name) {
		return first_name;
	} else if (last_name) {
		return last_name;
	} else {
		return "N/A";
	}
};

const timePeriod = (ap) => {
	const hour = moment(ap.booking_time_start, "HH:mm").hour();

	if (hour >= 6 && hour < 12) {
		return "Morning";
	} else if (hour >= 12 && hour < 18) {
		return "Afternoon";
	} else {
		return "Evening";
	}
};

const timeIcon = ref({
	Morning: "sunSetting02",
	Afternoon: "sun",
	Evening: "moonStar",
});

import { showDurationUnit } from "@utils";

const calculatePayment = (appointment_id, total) => {
	let totalPaid = 0;
	$transaction.getTransactions
		.filter(
			(transaction) =>
				transaction.appointment_id == appointment_id &&
				transaction.payment_status == "paid"
		)
		.forEach((transaction) => {
			totalPaid += Number(transaction.payment_amount);
		});
	return {
		totalPaid,
		totalDue: total - totalPaid,
		total,
	};
};
</script>


<template>
	<div class="md:max-w-[992px] m-auto mb-9 relative">
		<div v-if="!$appointment.isLoaded" class="absolute top-0 left-0 z-10 flex flex-col w-full gap-3 bg-white fade-out max-h-svh">
			<div class="w-56 h-16 bg-gray-200 rounded-md animate-pulse"></div>
			<div v-for="n in 4" class="w-full h-12 bg-gray-200 rounded-md animate-pulse"></div>
		</div>

		<div v-else>
			<EmptyPage v-if="!$appointment.getAppointments.length" :pageContent="emptyPageContent" />

			<div v-else>
				<PageHeading :title="$settings.labels.appointment?.plural" :subtitle="subtitle">
					<!-- <template #rightSide>
                        <Button size="md" type="tertiary_color" radius="square">Export CSV
                            <template #before>
                                <Icon name="share01" />
                            </template>
</Button>
					</template>-->
					<template #rightSide>
						<router-link v-if="access('appointment.add')" :to="{ name: 'appointment.add', query: { tab: 'details' } }">
							<Button size="md" type="tertiary_color" radius="square">
								Add New
								<template #before>
									<Icon name="plusCircle" />
								</template>
							</Button>
						</router-link>
					</template>
				</PageHeading>

				<!-- Filter -->
				<div class="md:flex gap-[52px] my-7 justify-between items-center w-full">
					<div class="w-full">
						<Input v-model="filter.search" class="w-full" :placeholder="`Search by ${String($settings.labels.customer?.singular).toLowerCase()}, ${String($settings.labels.service?.singular).toLowerCase()}, ${String($settings.labels.staff?.singular).toLowerCase()}`" iconLeft="searchLg"></Input>
					</div>
					<div class="flex gap-2 mt-2 md:mt-0 md:gap-5">
						<Select :options="bookingDatesOptions" v-model="filter.date" placeholder="Date" selectionContainer="py-[10px]" class="w-full lg:w-[191px]"></Select>
						<Select :options="statusOptions" v-model="filter.status" placeholder="Status" search selectionContainer="py-[10px]" class="w-full lg:w-[191px]"></Select>
					</div>
				</div>

				<!-- Actions -->
				<Transition name="router-animation">
					<Button v-if="getSelectedAppointments.length" size="md" type="secondary_gray" radius="square" @click.prevent="deleteSelected()" class="mb-5 border-[#FDA29B] text-[#B42318]">Delete</Button>
				</Transition>

				<!-- Appointments List-->
				<div class="overflow-scroll md:overflow-visible">
					<div class="bg-[linear-gradient(0deg,#eaecf0,transparent)] rounded-[0px_0px_8px_8px] p-[1px] mb-2">
						<div class="flex items-center py-2.5 text-[#667085] text-sm font-normal bg-white rounded-[0px_0px_8px_8px]">
							<div class="capitalize" :style="`padding-left: ${(16 * 3) + 20 + getWidth(getPaginatedAppointments.total).time}px`">{{ $settings.labels.service?.singular }}</div>
							<div class="capitalize" :style="`padding-left: ${getWidth(getPaginatedAppointments.total).service - 20}px`">{{ $settings.labels.customer?.singular }}</div>
							<div class="capitalize" :style="`padding-left: ${getWidth(getPaginatedAppointments.total).customer - 60}px`" v-if="$settings.addons.staffs">{{ $settings.labels.staff?.singular }}</div>
							<div class="capitalize" :style="`padding-left: ${$settings.addons.staffs ? getWidth(getPaginatedAppointments.total).staff - 20 : getWidth(getPaginatedAppointments.total).customer - 60}px`">Status</div>
						</div>
					</div>
					<Checkbox v-if="getPaginatedAppointments.total" v-model="state.allCheckbox" @click="toggleAll()" class="text-[#101828] text-sm font-semibold p-[12px_16px_8px_16px] mb-2 capitalize">{{ showFilterDateText }}</Checkbox>
					<div class="flex flex-col gap-2 mb-[28px]">
						<div v-for="(appointment, index) in getPaginatedAppointments.data" :key="index" :class="{
                            'shadow-[0px_24px_48px_-12px_rgba(16,24,40,0.18)]': activeAppointment === appointment.appointment_id,
                            'opacity-60 pointer-events-none grayscale': appointment.disabled
                        }" @click="toggleAppointmentItem($event, appointment.appointment_id)">
							<div class="h-[58px] appointment-item cursor-pointer flex items-center gap-4 py-2 px-4 rounded border border-solid border-[#EAECF0]" :class="{ 'opacity-70': activeAppointment !== appointment.appointment_id && activeAppointment !== '', 'bg-[#F9FAFB]': activeAppointment === appointment.appointment_id }">
								<!-- Checkbox -->
								<Checkbox v-if="appointment.meta" v-model="appointment.meta.checkbox" />

								<!-- Time  -->
								<div ref="time" class="w-[86px] flex items-center gap-1 whitespace-nowrap" @click="toggleAppointment(appointment.appointment_id)" :title="appointment.booking_date">
									<Icon :name="timeIcon[timePeriod(appointment) || 'Morning']" size="18px" class="text-[#D0D5DD]" />
									<div class="text-[#101828] text-xs font-medium">{{ getBookingTime(appointment) }}</div>
								</div>

								<!-- Service  -->
								<div ref="service" class="lg:w-[200px] py-3 px-3.5 rounded-[1px] text-[#101828] text-sm font-semibold whitespace-nowrap text-ellipsis overflow-hidden" @click="toggleAppointment(appointment.appointment_id)" :style="`background-color: ${toRGB($service.getServiceById(appointment.service_id)?.meta.color || '#000', 0.1)}; border-left: 3px solid ${$service.getServiceById(appointment.service_id)?.meta.color || '#000'}`" :title="$service.getServiceById(appointment.service_id)?.name || 'Untitled'">{{ $service.getServiceById(appointment.service_id)?.name || 'Untitled' }}</div>

								<!-- Customer  -->
								<div ref="customer" class="py-2 px-3 text-[#101828] text-sm font-medium cursor-pointer whitespace-nowrap text-ellipsis overflow-hidden" :class="$settings.addons.staffs ? 'lg:w-[180px]' : 'w-full'" @click="toggleAppointment(appointment.appointment_id)" v-if="appointment.meta" :title="generateCustomerName(appointment.meta.customer_first_name, appointment.meta.customer_last_name)">{{ generateCustomerName(appointment.meta.customer_first_name, appointment.meta.customer_last_name) }}</div>

								<!-- Staff  -->
								<div v-if="$settings.addons.staffs" ref="staff" class="flex items-center gap-2 lg:w-[120px] whitespace-nowrap text-ellipsis overflow-hidden" @click="toggleAppointment(appointment.appointment_id)">
									<ProfilePicture :name="$staff.getStaffById(appointment.staff_id)?.name" :img="$staff.getStaffById(appointment.staff_id)?.meta?.profile_image_url" :bgColor="$staff.getStaffById(appointment.staff_id)?.meta?.color" class="w-8 h-8" />
									<div class="text-[#344054] text-sm font-medium w-[calc(100%-40px)] truncate" :title="$staff.getStaffById(appointment.staff_id)?.name || 'Unassigned'">{{ $staff.getStaffById(appointment.staff_id)?.name || 'Unassigned' }}</div>
								</div>

								<!-- Status  -->
								<div class="whitespace-nowrap" v-if="appointment.meta">
									<Select :options="$options.appointment_statuses" v-model="appointment.meta.status" @change="changeStatus(appointment.appointment_id)" selectionContainer="!rounded-[100px] w-[125px] py-[8px]"></Select>
								</div>

								<!-- Actions  -->
								<div class="lg:w-[130px] flex items-center justify-end gap-4 whitespace-nowrap">
									<Icon :name="activeAppointment !== appointment.appointment_id ? 'chevronDown' : 'chevronUp'" size="28px" class="text-[#98A2B3] transition-all duration-300" @click="toggleAppointment(appointment.appointment_id)" />

									<Dropdown contentClass="w-56 top-[30px] right-0 w-[117px] z-[9]">
										<Icon name="dotsVertical" size="20px" class="text-[#98A2B3]" />

										<template #content>
											<div class="flex flex-col gap-1">
												<div class="rounded-md mx-1.5 my-0.5 transition">
													<router-link v-if="access('appointment.edit')" :to="{ name: 'appointment.edit', params: { appointmentId: appointment.appointment_id }, query: { backTo: route.fullPath } }" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
														<Icon size="16px" name="edit05" />
														<div class="text-[#344054] text-sm font-medium">Edit</div>
													</router-link>
												</div>
												<div class="rounded-md mx-1.5 my-0.5 transition">
													<div @click="deleteAppointment(appointment)" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
														<Icon size="16px" name="trash01" />
														<div class="text-[#344054] text-sm font-medium">Delete</div>
													</div>
												</div>
											</div>
										</template>
									</Dropdown>
								</div>
							</div>

							<Transition name="slide-fade">
								<div class="px-5 py-6" v-if="activeAppointment == appointment.appointment_id">
									<div class="flex items-center justify-between gap-6">
										<!-- Customer  -->
										<div class="flex items-center gap-3">
											<!-- <img :src="appointment.member.image" class="w-10 h-10 rounded-full" :alt="appointment.meta.name"> -->
											<ProfilePicture :name="$customer.findCustomerById(appointment.customer_id)?.name" :img="$customer.findCustomerById(appointment.customer_id)?.meta.profile_image_url" :bgColor="$customer.findCustomerById(appointment.customer_id)?.meta?.color" class="w-5 h-5" textClass="!text-[12px]" />
											<div class="text-[#101828] text-lg font-semibold" v-if="appointment.meta">{{ generateCustomerName(appointment.meta.customer_first_name, appointment.meta.customer_last_name) }}</div>
										</div>

										<!-- Location  -->
										<div class="flex items-center gap-6">
											<!-- address  -->
											<!-- <div v-if="appointment.meta" class="flex items-center gap-2">
                                                <Icon name="markerPin01" size="20px" class="text-[#98A2B3]" />
                                                <div class="text-[#101828] text-sm font-normal whitespace-nowrap text-ellipsis overflow-hidden" :title="appointment.meta.address">{{ appointment.meta.address || 'N/A' }}</div>
											</div>-->

											<!-- email  -->
											<div v-if="appointment.meta" class="flex items-center gap-2">
												<Icon name="mail01" size="20px" class="text-[#98A2B3]" />
												<div class="text-[#101828] text-sm font-normal whitespace-nowrap text-ellipsis overflow-hidden" :title="appointment.meta.customer_email">{{ appointment.meta.customer_email || 'N/A' }}</div>
											</div>

											<!-- phone  -->
											<div v-if="appointment.meta" class="flex items-center gap-2">
												<Icon name="phoneCall01" size="20px" class="text-[#98A2B3]" />
												<div class="text-[#101828] text-sm font-normal whitespace-nowrap text-ellipsis overflow-hidden" :title="appointment.meta.customer_phone">{{ appointment.meta.customer_phone || 'N/A' }}</div>
											</div>
										</div>
									</div>
									<div class="bg-[#EAECF0] h-[1px] my-4"></div>
									<div class="flex items-center justify-between">
										<!-- Meta  -->
										<div class="flex flex-col gap-1 text-sm">
											<div class="text-[#667085] font-normal">Type</div>
											<div class="text-[#101828] font-semibold capitalize">{{ appointment.meta.type || 'onsite' }}</div>
										</div>
										<div class="flex flex-col gap-1 text-sm">
											<div class="text-[#667085] font-normal capitalize">{{ $settings.labels.payment?.singular }} Method</div>
											<div class="text-[#101828] font-semibold capitalize">{{ appointment.meta.payment_method || 'cash' }}</div>
										</div>
										<div class="flex flex-col gap-1 text-sm">
											<div class="text-[#667085] font-normal">Duration</div>
											<!-- <div class="text-[#101828] font-semibold">{{ (appointment.meta.service_duration * (appointment.meta.duration_type == 'hours' ? 60 : 1)) || 0 }} min</div> -->
											<div class="text-[#101828] font-semibold">{{ showDurationUnit(appointment.meta.service_duration, appointment.meta?.service_duration_unit) }}</div>
										</div>
										<div class="flex flex-col gap-1 text-sm">
											<div class="text-[#667085] font-normal">Paid</div>
											<div class="text-[#101828] font-semibold">{{ calculatePayment(appointment.appointment_id, appointment.meta.price)?.totalPaid }}</div>
										</div>
										<div class="flex flex-col gap-1 text-sm">
											<div class="text-[#667085] font-normal">Due</div>
											<div class="text-[#101828] font-semibold">{{ calculatePayment(appointment.appointment_id, appointment.meta.price)?.totalDue }}</div>
										</div>
										<div class="flex flex-col gap-1 text-sm">
											<div class="text-[#667085] font-normal">Total Price</div>
											<div class="text-[#101828] font-semibold">{{ getPrice(appointment.meta.price || 0) }}</div>
										</div>
									</div>
									<div class="bg-[#EAECF0] h-[1px] my-4"></div>
									<div v-if="appointment.meta.customer_note" class="flex gap-6 text-sm font-normal">
										<div class="text-[#667085] text-nowrap">Customer’s Note</div>
										<div class="text-[#101828]" v-if="appointment.meta">{{ appointment.meta.customer_note }}</div>
									</div>
								</div>
							</Transition>
						</div>
						<div v-if="getPaginatedAppointments.total == 0" class="text-center text-[#b84646]">No appointment found</div>
					</div>
					<Pagination v-if="getPaginatedAppointments.total !== 0" class="pt-[20px]" :totalItems="getPaginatedAppointments.total" v-model:currentPage="currentPage"></Pagination>
				</div>
			</div>
		</div>
	</div>
</template>